module.exports = __webpack_public_path__ + "img/fdomes.757af5c4.jpg";